<template>
  <div class="container">
    <b-alert
      variant="success"
      class="thank-you-message mt-4"
      show
    >
      {{ getContentItem("backorderThankyou") }}
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "ThankYou",
    computed: {
      ...mapGetters(["getContentItem"]),
    },
  };
</script>
